import builder from '../builder';
import Like2 from '../../streamline-icons/light/like-2.svg';

export default builder('IconLike2Light', Like2);
